import { useEffect, useState } from "react";
import Container from "../../components/general/container/Container";
import { Breadcrumb } from "antd";
import ProductGrid from "../../components/general/productGrid.tsx/ProductGrid";
import { IProduct } from "../../models/product";
import http from "../../api/api";
import { Link, useLocation, useParams } from "react-router-dom";

const CategorySub = () => {
  const { sub } = useParams();
  const [categoryProducts, setCategoryProducts] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await http.get(`/subCategory/${sub}/products`);

        setCategoryProducts(data.data);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [sub]);

  const { state } = useLocation();
  const { name } = state;

  return (
    <>
      <Container>
        <Breadcrumb
          separator={<div className="text-[24px]">{`>`}</div>}
          items={[
            {
              title: (
                <Link className="text-[24px] p-[24px] hover:h-auto" to={"/"}>
                  الرئيسية
                </Link>
              ),
            },
            {
              title: name ?? "",
              className: "text-[24px]",
            },
          ]}
        />
        <div className="mt-[70px]">
          <ProductGrid loading={loading} products={categoryProducts} />

          <div className="flex mt-[40px] justify-end">
            {/* <Pagination /> */}
          </div>
        </div>
      </Container>
    </>
  );
};

export default CategorySub;
